import { APIResponse, defaultMetaQueryFn } from 'api';
import { DateRange } from 'common/DateRange';
import { ReportType } from 'components/shared/DownloadMenu/DownloadMenu';
import { DealerStepReportPayload } from 'models';
import { useQuery } from 'react-query';
import { getApiDateStringFromDate } from 'utils/time';

const requestPath: string = '/reports/step';

export function useDealerStepReport({ start, end }: DateRange) {
  const params = `startDate=${getApiDateStringFromDate(
    start
  )}&endDate=${getApiDateStringFromDate(end)}`;
  const url = `${requestPath}?${params}`;
  const key = [
    requestPath,
    getApiDateStringFromDate(start),
    getApiDateStringFromDate(end),
  ];

  return useQuery<APIResponse<DealerStepReportPayload>>(key, () =>
    defaultMetaQueryFn(url)
  );
}

const getDownloadUrl = (exportType: ReportType, dateRange: DateRange) => {
  const url = '/reports/export/step?';
  const params = {
    startDate: getApiDateStringFromDate(dateRange.start),
    endDate: getApiDateStringFromDate(dateRange.end),
    exportType,
  };
  return (
    url +
    Object.entries(params)
      .filter((entry) => entry[1] !== undefined)
      .map(([key, value]) => `${key}=${value}`)
      .join('&')
  );
};

export function useDealerStepReportDownloadLink(
  reportType: ReportType | null,
  dateRange: DateRange
) {
  const downloadUrl =
    reportType !== null ? getDownloadUrl(reportType, dateRange) : '';
  const result = useQuery<{ uri: string }>(downloadUrl, {
    enabled: reportType !== null,
  });
  return {
    isLoading: result.isLoading,
    downloadFileUrl: result?.data?.uri,
  };
}

export function useReportTimeInStep(stepId: string, dateRange: DateRange) {
  const path = `/reports/steps/${stepId}/timeInStep?`;
  const params = {
    startDate: getApiDateStringFromDate(dateRange.start),
    endDate: getApiDateStringFromDate(dateRange.end),
  };
  const url =
    path +
    Object.entries(params)
      .filter((entry) => entry[1] !== undefined)
      .map(([key, value]) => `${key}=${value}`)
      .join('&');

  return useQuery<
    APIResponse<{
      [key: string]: { reconTimeInStep: number; retailTimeInStep: number };
    }>
  >(url, () => defaultMetaQueryFn(url));
}
